import { styled } from '@/styles/stitches.config';
import { ComposableStyledComponentProps } from '@/types/composable-styled-component';
import { Trans } from '@lingui/macro';
import { Card as RelatedStoryCard } from '../card';
import { useLingui } from '@lingui/react';
import { stories } from '../overview';
import { useMemo } from 'react';

type RelatedStoryProps = ComposableStyledComponentProps & {
  id: string;
};

const Root = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  gap: '$5',
  marginBlockEnd: '$6',
});

const LearnMore = styled('p', {
  maxWidth: '25ch',
  color: 'var(--color-text-light)',
  marginBlockEnd: 0,

  '@supports not (gap: $5)': {
    marginBlockEnd: '$5',
  },
});

export function RelatedStory({ css, id }: RelatedStoryProps) {
  const { i18n } = useLingui();

  const story = stories(i18n).find((story) => story.id === id);

  if (!story) return null;

  return (
    <Root css={css}>
      <LearnMore>
        <Trans id="common.related-story.text">
          Learn more about this aspect of how childhood is changing.
        </Trans>
      </LearnMore>

      {/* Replace with card for the related story when that component is finished */}
      <RelatedStoryCard
        css={{
          fontSize: '$3',
          boxShadow: '0 0 1em 0 $colors$shadows',
          borderRadius: '$space$5',
          width: '17.5rem',
          height: 'calc(17.5rem * 1.4)',

          '@supports (aspect-ratio: 1 / 1.4)': {
            aspectRatio: '1 / 1.4',
          },
        }}
        href={story.href}
        id={story.id}
        theme={story.theme}
        themeLabel={story.themeLabel}
        title={story.title}
        status={story.status}
      />
    </Root>
  );
}
